import { animate, animateChild, group, query, style, transition, trigger } from '@angular/animations';

const timings = '800ms cubic-bezier(0.25, 0.8, 0.25, 1)';

export const slideInAnimation =
  trigger('routeAnimations', [
    transition('void => *', [
      style({
        transform: 'none'
      }),
      query(':enter', [
        style({
          transform: 'translateX(-100%)'
        })
      ], {
        optional: true
      }),
      group([
        query(':enter', [
          animate(timings, style({ transform: 'translateX(0)' }))
        ], {
          optional: true
        }),
        query('@*', animateChild(), {
          optional: true
        })
      ])
    ]),
    transition('* <=> *', [
      style({
        transform: 'none'
      }),
      query(':leave', [
        style({
          transform: 'translateX(0%)'
        })
      ], {
        optional: true
      }),
      query(':enter', [
        style({
          transform: 'translateX(-200%)'
        })
      ], {
        optional: true
      }),
      query(':leave', animateChild(), {
        optional: true
      }),
      group([
        query(':leave', [
          animate(timings, style({ transform: 'translateX(100%)', opacity: 0 }))
        ], {
          optional: true
        }),
        query(':enter', [
          animate(timings, style({ transform: 'translateX(-100%)' }))
        ], {
          optional: true
        }),
        query('@*', animateChild(), {
          optional: true
        })
      ])
    ])
  ]);